module.exports = __webpack_public_path__ + "assets/img/splash.0e5737c2.png";